var React = require('react');

function ActivitiesDarkIcon (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.activities-dark-icon-svg{fill:#1F5B8F;}\n"),React.createElement("path",{"className":"activities-dark-icon-svg","d":"M9,20c1.1,0,2-0.9,2-2.1H7C7,19.1,7.9,20,9,20z M15,13.8V8.7c0-3.1-1.6-5.8-4.5-6.5V1.5C10.5,0.7,9.8,0,9,0\n\tS7.5,0.7,7.5,1.5v0.7C4.6,2.9,3,5.6,3,8.7v5.1l-2,2.1v1h16v-1L15,13.8z","key":1})]);
}

ActivitiesDarkIcon.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 17 20","style":{"enableBackground":"new 0 0 17 20"},"xmlSpace":"preserve"};

module.exports = ActivitiesDarkIcon;

ActivitiesDarkIcon.default = ActivitiesDarkIcon;
